//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockInventoryRegradingRecords from './StockInventoryRegradingRecords.vue'

export default {
  components: {
    StockInventoryRegradingRecords
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    request: function () {
      return this.record.request
    }
  },
  created: function () {
  },
  methods: {
    onSave: function () {
      this.$emit('save')
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

